import { HttpStatus } from '@/constants/http-status';
import { HOME } from '@/constants/routes';
import { AuthSessionEventTypes } from '@/constants/auth';
import { publishAuthSessionEvent } from '@/utils/auth-session-channel';

// Authorization checks during navigation
export default defineNuxtRouteMiddleware((to) => {
    const error = useError();

    // Rendering an error page is an entirely separate page load - skip auth checks if this is the case
    if (error.value && error.value.fatal) {
        return;
    }

    const userSession = useUserSessionStore();

    if (userSession.hasAccessTokenExpired()) {
        userSession.clear();
        publishAuthSessionEvent(AuthSessionEventTypes.SignedOut);
    }

    if (useAuth().isRouteAccessible(to)) {
        return;
    }

    const { unauthorizedRedirectTo } = useRuntimeConfig().public.auth;

    if (!userSession.isAuthenticated) {
        return navigateTo({
            path: unauthorizedRedirectTo,
            query: { redirect: to.path === HOME ? undefined : to.fullPath }
        });
    } else {
        throw createError({ statusCode: HttpStatus.Unauthorized, fatal: true });
    }
});
